import { Badge } from "@material-ui/core";
import {
  // AccountCircleOutlined,
  // ExitToAppOutlined,
  Menu,
  ShoppingCartOutlined,
} from "@material-ui/icons";
import styled from "styled-components";
import usePublishedHeight from "../hooks/usePublishedHeight";
import { NAV_H_VAR } from "../utils/stickyStack";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
// import { logoutUser } from "../redux/apiCalls";
import { Image } from "react-bootstrap";

import { mobile } from "../responsive";
import SearchIcon from "../assets/img/search_icon.png"
import { globalSearch, clearSearch } from "../redux/globalSearchSlice";
import { useCartCount } from "../redux/cartCount";
import { useRef, useState } from "react";
import LocationPrompt from "./LocationPrompt";
import {
  signInLocation,
  signInReturnPath,
  pathOfLocation,
  isSafeReturnPath,
  recordSignInReturn,
} from "../utils/signInReturn";
/* Default brand color used by the marketplace (homepage, search, etc.).
   Pages can override with the `bgColor` prop on <Navbar /> to give a
   subtle visual cue when the user is browsing inside a specific
   vendor's shop (e.g. retailer/wholesaler, restaurant, healthcare). */
const DEFAULT_NAV_BG = "#324d54";

/* Explicit left/right anchoring is important: when the Navbar is
   rendered inside a parent that has horizontal padding (e.g. the
   vendor shop or search results pages), position:fixed without a
   left offset falls back to the static position, which sits at the
   parent content edge and exposes a sliver of the page background
   on the left. Pinning left:0 / right:0 keeps the bar flush. */
const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  background-color: ${(props) => props.$bgColor || DEFAULT_NAV_BG};
`;

const Wrapper = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.$bgColor || DEFAULT_NAV_BG};
  position: relative;
  box-sizing: border-box;

  @media only screen and (max-width: 850px) {
    flex-direction: column;
    align-items: stretch;
    padding: 8px 12px 0 12px;
    gap: 8px;
  }
`;

const MobileTopRow = styled.div`
  display: none;

  @media only screen and (max-width: 850px) {
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;
  }
`;

const MobileBottomRow = styled.div`
  display: none;

  @media only screen and (max-width: 850px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 8px;
    gap: 6px;
  }
`;

const Logo = styled.div`
  font-weight: bold;
  display: flex;
  align-items: center;
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 850px) {
    display: none;
  }
`;

// const MobileLocationRow = styled.div`
//   display: none;

//   @media only screen and (max-width: 850px) {
//     display: flex;
//     justify-content: center;
//     width: 100%;
//   }
// `;

const DesktopLocationWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 850px) {
    display: none;
  }
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media only screen and (max-width: 850px) {
    display: none;
  }
`;

const MobileRight = styled.div`
  display: none;

  @media only screen and (max-width: 850px) {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    flex-shrink: 0;
  }
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  margin-left: 25px;
  overflow: visible;
  @media only screen and (max-width: 850px) {
    margin-left: 8px;
    font-size: 12px;
  }
`;

const CartIconItem = styled.div`
  margin-right: 25px;
  overflow: visible;
  @media only screen and (max-width: 850px) {
    margin-right: 0;
  }
`;

const StyledButton = styled(Link)`
  padding: 4px 10px;
  margin: 1px;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  background-color: transparent;
  transition: ease-in-out 0.3s;
  color: white;
  font-size: 11px;
  border: 1px solid rgba(255,255,255,0.6);
  border-radius: 16px;
  white-space: nowrap;
  &:hover {
    background-color: rgba(255,255,255,0.15);
    color: white;
    cursor: pointer;
  }

  @media only screen and (max-width: 480px) {
    padding: 4px 7px;
    font-size: 10px;
  }
`;

const AuthButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 4px;
`;

const ClickableMenu = styled(Menu)`
  font-size: 34px;
  color: white;
  margin-left: 20px;
  opacity: 0.8;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #ff6347; // Tomato color when mouse hovers over it
  }

  &:active {
    transform: scale(0.9);
  }

  &:focus {
    outline: 2px solid #ff6347; // Outline with tomato color when it gets focus
  }
`;


const Center = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 850px) {
    display: none;
  }
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: stretch;
  border: 1px solid lightgray;
  border-radius: 10px;
  flex: 2;
  padding: 0;
  margin-right: 25px;
  width: 100%;

  @media only screen and (max-width: 850px) {
    margin-right: 0;
  }
`;

const MobileLocationBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

const MobileSearchContainer = styled.div`
  display: none;

  @media only screen and (max-width: 850px) {
    display: flex;
    align-items: stretch;
    border: 1px solid lightgray;
    border-radius: 10px;
    width: 100%;
  }
`;

const Input = styled.input`
flex-grow: 1; // Allows the input to grow and fill the space
padding: 10px;
padding-left: 32px; // Increased padding to account for the search icon
font-size: 14px;
border: none;
border-radius: 10px 0 0 10px;
box-sizing: border-box;
background: white url(${SearchIcon}) no-repeat 10px center;
background-repeat: no-repeat;
background-position: 10px center; // Position it 10px from the left, centered vertically
background-size: 17px; // Size of the search icon
margin: 0;
  &:focus {
    outline: none;
  }
  ${mobile({
  // width: "auto", 
  flexGrow: 1
})}
`;

const SearchButton = styled.button`
  padding: 10px 15px;
  font-size: 12px;
  border: none;
  background-color: #83B524;
  color: white;
  cursor: pointer;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: -6px 2px 10px rgba(0, 0, 0, 0.55);
  &:focus {
    outline: none;
    background-color: #699B07;
  }
  &:hover {
    background-color: #699B07;
  }
`;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Navbar = ({ bgColor }) => {
  // const quantity = useSelector((state) => state.cart.quantity);
  const user = useSelector((state) => state.user.currentUser);
  const query = useQuery();
  // Every cart the shopper has, as the cart hub lists them (redux/cartCount).
  const cartCount = useCartCount();

  const dispatch = useDispatch();
  // const page = query.get("page") || 1;
  // const searchQuery = query.get("searchQuery");
  const history = useHistory();
  const location = useLocation();
  const [search, setSearch] = useState(query.get("searchQuery") || "");
  /* Sign In and Register bring the shopper back to the page they left. On a
     sign-in page itself they pass along the return path it already carries. */
  const currentPath = pathOfLocation(location);
  const returnPath = isSafeReturnPath(currentPath) ? currentPath : signInReturnPath(location);
  const signInLink = signInLocation(returnPath);
  const registerLink = signInLocation(returnPath, "/register");


  const goToDashBoard = (e) => {
    e.preventDefault();
    history.push("/my_profile");
  };

  const searchListings = () => {
    if (search.trim()) {
      dispatch(globalSearch(search.trim()));
      history.push(`/search?q=${encodeURIComponent(search.trim())}`);
    } else {
      dispatch(clearSearch());
      history.push("/"); // Go to home if search is empty
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      searchListings();
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (value === "") {
      dispatch(clearSearch());
    }
  };


  // Publish the ACTUAL rendered navbar height as a CSS variable so pages can
  // offset fixed-header content correctly on EVERY breakpoint — the stacked
  // mobile layout is ~200px tall, not the old hardcoded 130px, which hid page
  // titles under the search bar. Pages consume it as
  //   padding-top: var(--lusuku-nav-h, 130px)
  // — the 130px fallback keeps any untouched page exactly as before, and the
  // unmount cleanup lets vendor-navbar pages fall back too.
  const navRef = useRef(null);
  usePublishedHeight(navRef, NAV_H_VAR);

  return (
    <Container ref={navRef} $bgColor={bgColor}>
      <Wrapper $bgColor={bgColor}>
        {/* ── Desktop layout ── */}
        <Left>
          <Logo>
            <Link to="/">
              {/* `lusuku_logo_main.png` is the current wordmark badge
                  (green leaf ring + "LUSUKU" text). It replaces the
                  generic `/logo192.png` favicon-style PWA icon that
                  CRA ships with — the favicon was fine for the browser
                  tab but reads as a placeholder in the navbar. Served
                  straight from /public so no import/bundler round-trip. */}
              <Image
                src="/lusuku_logo_main.png"
                alt="Lusuku"
                style={{
                  width: 95,
                  height: 95,
                  marginBottom: 10,
                  marginRight: 8,
                  imageRendering: "-webkit-optimize-contrast",
                }}
              />
            </Link>
          </Logo>
          <DesktopLocationWrapper>
            <LocationPrompt compact />
          </DesktopLocationWrapper>
        </Left>
        <Center>
          <SearchContainer>
            <Input
              type="search"
              id="search"
              placeholder="Search products, brands and categories..."
              value={search}
              onChange={handleInputChange}
              onKeyDown={handleKeyPress}
            />
            <SearchButton onClick={searchListings}>SEARCH</SearchButton>
          </SearchContainer>
        </Center>
        {!user ? (
          <Right>
            <StyledButton to="/blog" style={{ marginRight: 6 }}>Insights</StyledButton>
            <AuthButtonGroup>
              <StyledButton to={registerLink} onClick={() => recordSignInReturn(returnPath)}>Register</StyledButton>
              <StyledButton to={signInLink} onClick={() => recordSignInReturn(returnPath)}>Sign In</StyledButton>
            </AuthButtonGroup>
            <Link to="/cart">
              <CartIconItem>
                <MenuItem>
                  <Badge badgeContent={cartCount} color="secondary" overlap="rectangular">
                    <ShoppingCartOutlined style={{ color: "#f8f4f4", fontSize: 34 }} />
                  </Badge>
                </MenuItem>
              </CartIconItem>
            </Link>
          </Right>
        ) : (
          <Right>
            <StyledButton to="/blog" style={{ marginRight: 6 }}>Insights</StyledButton>
            <Link to="/cart">
              <MenuItem>
                <Badge overlap="rectangular" badgeContent={cartCount} color="secondary">
                  <ShoppingCartOutlined style={{ color: "#f8f4f4", fontSize: 34 }} />
                </Badge>
              </MenuItem>
            </Link>
            <ClickableMenu
              style={{
                fontSize: 34,
                marginRight: 10,
              }}
              onClick={goToDashBoard}
            />
          </Right>
        )}
        {/* ── Mobile layout ── */}
        <MobileTopRow>
          <Logo>
            <Link to="/">
              {/* Same `lusuku_logo_main.png` as the desktop Left logo —
                  keeps the brand mark consistent across breakpoints
                  (previously the mobile row reused the PWA icon too). */}
              <Image
                src="/lusuku_logo_main.png"
                alt="Lusuku"
                style={{ width: 52, height: 52, marginRight: 8, imageRendering: "-webkit-optimize-contrast" }}
              />
            </Link>
          </Logo>
          {!user ? (
            <MobileRight>
              <AuthButtonGroup>
                <StyledButton to={registerLink} onClick={() => recordSignInReturn(returnPath)}>Register</StyledButton>
                <StyledButton to={signInLink} onClick={() => recordSignInReturn(returnPath)}>Sign In</StyledButton>
              </AuthButtonGroup>
              <Link to="/cart" style={{ marginRight: 16 }}>
                <Badge badgeContent={cartCount} color="secondary" overlap="rectangular">
                  <ShoppingCartOutlined style={{ color: "#f8f4f4", fontSize: 22 }} />
                </Badge>
              </Link>
            </MobileRight>
          ) : (
            <MobileRight>
              <Link to="/cart" style={{ display: "flex", alignItems: "center" }}>
                <Badge overlap="rectangular" badgeContent={cartCount} color="secondary">
                  <ShoppingCartOutlined style={{ color: "#f8f4f4", fontSize: 22 }} />
                </Badge>
              </Link>
              <ClickableMenu style={{ fontSize: 28, marginLeft: 0 }} onClick={goToDashBoard} />
            </MobileRight>
          )}
        </MobileTopRow>
        <MobileBottomRow>
          <MobileLocationBar>
            <LocationPrompt compact />
          </MobileLocationBar>
          <MobileSearchContainer>
            <Input
              type="search"
              id="search-mobile"
              placeholder="Search products, brands and categories..."
              value={search}
              onChange={handleInputChange}
              onKeyDown={handleKeyPress}
            />
            <SearchButton onClick={searchListings}>SEARCH</SearchButton>
          </MobileSearchContainer>
        </MobileBottomRow>
      </Wrapper>
    </Container>

  );
};

export default Navbar;
